import {
  CARD_NAME,
  REGEX_PATTERN_EMAIL,
  REGEX_PATTERN_WHITESPACE,
} from "./global";
import lang from "../assets/i18n/en.json";
import exportimages from "../assets/images/exportImages";
import html2canvas from "html2canvas";
import { PDFstyles } from "../Components/Bank/widget/FinancialHealthScore/FinancialHealthScoreDetails/FinancialHealthScoreDetailsPDF";

export function addCommas(number) {
  if (number == null || Number.isNaN(number)) {
    return "0";
  }

  const num = Number(number);

  // Round to 2 decimal places first
  const rounded = Math.round(num * 100) / 100;

  // If rounded result is an integer → no decimals
  if (Number.isInteger(rounded)) {
    return rounded.toLocaleString("en-US");
  }

  // Otherwise keep exactly 2 decimals
  return rounded.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export const validateEmail = (emailId, errors, setError) => {
  let email = emailId.trim();
  const regex = REGEX_PATTERN_EMAIL();
  const whiteSpace = REGEX_PATTERN_WHITESPACE();

  // Check if user has entered at least one character after '@'
  const isCompleteEmail =
    email?.includes("@") || email?.split("@")[1]?.includes(".");
  // let workMail = !(
  //   checkWorkEmail.includes("gmail") ||
  //   checkWorkEmail.includes("yahoo") ||
  //   checkWorkEmail.includes("outlook") ||
  //   checkWorkEmail.includes("hotmail") ||
  //   checkWorkEmail.includes("aol")
  // );
  // Perform validation only when it's a more complete email
  if (isCompleteEmail) {
    if (regex.test(email) && email.match(whiteSpace) && email.length < 500) {
      setError((errors) => ({
        ...errors,
        email: false,
        emailError: "",
      }));
    } else if (email.length > 500) {
      setError((errors) => ({
        ...errors,
        email: true,
        emailError: lang?.PAGE?.AUTH?.SIGNUP?.EMAIL?.MAX_LENGTH,
      }));
    } else {
      setError((errors) => ({
        ...errors,
        email: true,
        emailError: "Must enter a valid work email address.",
      }));
    }
  } else {
    // Clear the error if the user hasn't finished entering the email
    setError((errors) => ({
      ...errors,
      email: true,
      emailError: "",
    }));
  }
};

export const validateDateTime = (value, errors, setError) => {
  /** VALIDATING Date and time  */
  const selectedDateTime = new Date(value).getTime();
  const currentDateTime = Date.now();
  if (value === "") {
    setError((errors) => ({
      ...errors,
      scheduledFor: true,
      scheduledForError: "Scheduled date cannot be empty!",
    }));
  } else if (selectedDateTime < currentDateTime) {
    setError((errors) => ({
      ...errors,
      scheduledFor: true,
      scheduledForError:
        "Please select a time that is ahead of the current time.",
    }));
  } else {
    setError((errors) => ({
      ...errors,
      scheduledFor: false,
      scheduledForError: "",
    }));
  }
};

export const validateEmailTemplate = (data) => {
  if (!data?.design?.body) {
    return true;
  }
  const {
    design: { body },
  } = data;
  const { rows } = body;
  let isEmpty = true;

  for (const row of rows) {
    const { columns } = row;
    for (const column of columns) {
      const { contents } = column;
      if (contents.length) {
        isEmpty = false;
        break;
      }
    }
    if (!isEmpty) break;
  }

  return isEmpty;
};

export function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let c of ca) {
    while (c.startsWith(" ")) {
      c = c.substring(1);
    }
    if (c.startsWith(name)) {
      return c.substring(name.length);
    }
  }
  return "";
}

export function deleteAllCookies() {
  let cookies = document.cookie.split(";");
  for (let cookie of cookies) {
    let eqPos = cookie.indexOf("=");
    let name = eqPos > -1 ? cookie.slice(0, eqPos) : cookie;
    document.cookie =
      name +
      "=;" +
      "expires=Thu, 01-Jan-1970 00:00:01 GMT;" +
      "path=" +
      "/;" +
      "domain=" +
      globalThis.location.host +
      ";" +
      "secure=;";
  }
}

export const fetchCurrentCachedState = (cachedQueries) => {
  const result = {};

  if (!cachedQueries) return result;

  Object.values(cachedQueries).forEach((item) => {
    if (item?.status === "fulfilled") {
      const key = `${item.endpointName}`;
      result[key] = item?.data?.data;
    }
  });

  return result;
};

export const checkImage = (template) => {
  const base_url = process.env.REACT_APP_CAMPAIGN_THUMBNAIL_URL;
  const url = `${base_url}${template?.templateThumbnail[0]?.url}`;
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve(true); // Image is valid
    };
    img.onerror = () => {
      resolve(false); // Image is invalid
    };
    img.src = url;
  });
};

export const getThumbnailImage = (isValid, item) => {
  const base_url = process.env.REACT_APP_CAMPAIGN_THUMBNAIL_URL;
  if (isValid) {
    return {
      image: `${base_url}${item?.templateThumbnail[0]?.url}`,
      alt: item?.name,
      content: `${item?.templateThumbnail[0]?.content}`,
    };
  } else {
    return {
      image: exportimages?.no_image,
      defaultType: true,
      alt: item?.name,
    };
  }
};

export const formatToDollar = (value) => {
  let dollarUSLocale = Intl.NumberFormat("en-US");
  return dollarUSLocale.format(Math.round(Number(value)));
};

export const getDifferenceClass = (
  forecastedValue,
  currentValue,
  is_reverse,
) => {
  let classString = "";
  if (is_reverse === "true") {
    if (forecastedValue > currentValue) {
      classString += "red-color upward-arrow-red";
    } else if (forecastedValue < currentValue) {
      classString += "green-color downward-arrow-green";
    } else {
      classString += "orange-color";
    }
  } else if (is_reverse === "false") {
    if (forecastedValue > currentValue) {
      classString += "green-color upward-arrow-green";
    } else if (forecastedValue < currentValue) {
      classString += "red-color downward-arrow-red";
    } else {
      classString += "orange-color";
    }
  }
  return classString;
};

//new code - 27-02-2025 for fhs page only
export const getDifferenceClassForFHS = (
  forecastedValue,
  currentValue,
  is_reverse,
) => {
  if (forecastedValue === currentValue) return "orange-color";

  const isReverse = is_reverse === "true";
  const isIncrease = forecastedValue > currentValue;

  const direction = isIncrease ? "upward" : "downward";

  let color;
  if (isReverse) {
    color = isIncrease ? "red" : "green";
  } else {
    color = isIncrease ? "green" : "red";
  }

  const alignment = "align-middle";

  return `bg-transparent ${color}-${direction}-arrow ${alignment} arrow-dimension`;
};

export const getArrowIndicatorClass = (triggerFrom, showAPValue, segment) => {
  // Early return for equal values
  if (
    Number(segment?.current) === Number(segment?.forecasted) &&
    Number(segment?.current) === Number(segment?.final_AP_value)
  ) {
    return "";
  }

  const classStringForecasted = getDifferenceClassForFHS(
    segment?.forecasted,
    segment?.current,
    segment?.is_reverse,
  );
  const classStringAPValue = getDifferenceClassForFHS(
    segment?.final_AP_value,
    segment?.current,
    segment?.is_reverse,
  );
  const isForecastTrigger = triggerFrom === "isForcasted";
  const valuesAreDifferent =
    Number(segment?.forecasted) !== Number(segment?.final_AP_value);

  if (!valuesAreDifferent) {
    return isForecastTrigger ? classStringForecasted : classStringAPValue;
  }

  return getConflictingIndicatorClass(
    classStringForecasted,
    classStringAPValue,
    isForecastTrigger,
    showAPValue,
  );
};

const getConflictingIndicatorClass = (
  classStringForecasted,
  classStringAPValue,
  isForecastTrigger,
  showAPValue,
) => {
  if (!showAPValue) {
    return isForecastTrigger ? classStringForecasted : classStringAPValue;
  }

  const hasGreen =
    classStringForecasted.includes("green") ||
    classStringAPValue.includes("green");
  const hasRed =
    classStringForecasted.includes("red") || classStringAPValue.includes("red");

  if (hasGreen) {
    return isForecastTrigger
      ? classStringForecasted.replaceAll("green", "orange")
      : classStringAPValue;
  }

  if (hasRed) {
    return isForecastTrigger
      ? classStringForecasted
      : classStringAPValue.replaceAll("red", "orange");
  }

  return isForecastTrigger ? classStringForecasted : classStringAPValue;
};

export const getArrowIndicatorBase64Image = (
  triggerFrom,
  showAPValue,
  segment,
) => {
  const indicatorClassString = getArrowIndicatorClass(
    triggerFrom,
    showAPValue,
    segment,
  );

  return indicatorClassString?.split(" ")[1]?.replaceAll("-", "_");
};

export const getDifferencePropsForFHS = (
  forecastedValue,
  currentValue,
  is_reverse,
) => {
  if (is_reverse === "true") {
    if (forecastedValue > currentValue) {
      return { style: PDFstyles.redUp, symbol: "\u25B2" }; // ▲
    } else if (forecastedValue < currentValue) {
      return { style: PDFstyles.greenDown, symbol: "\u25BC" }; // ▼
    } else {
      return { style: PDFstyles.orangeNeutral, symbol: "" }; // no change
    }
  } else if (is_reverse === "false") {
    if (forecastedValue > currentValue) {
      return { style: PDFstyles.greenUp, symbol: "\u25B2" }; // ▲
    } else if (forecastedValue < currentValue) {
      return { style: PDFstyles.redDown, symbol: "\u25BC" }; // ▼
    } else {
      return { style: PDFstyles.orangeNeutral, symbol: "" }; // no change
    }
  }

  return { style: PDFstyles.orangeNeutral, symbol: "" }; // default fallback
};

export function getRangeCategory(value) {
  if (value >= 1 && value <= 40) {
    return "requires action";
  } else if (value >= 41 && value <= 65) {
    return "needs attention";
  } else if (value >= 66 && value <= 85) {
    return "good";
  } else if (value >= 86 && value <= 100) {
    return "optimal";
  }
}

export const minDateInCalander = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();
  const day = today.getDate();

  const minDate = new Date(year, month, day);

  minDate.setHours(0, 0, 0, 0);
  return minDate;
};

export function calculatePercentage(data) {
  const percentCalculate =
    data?.current === 0
      ? 0
      : ((data?.forecasted - data?.current) / Math.abs(data?.current)) * 100;
  return Number(percentCalculate.toFixed(2));
}

//new code - 27-02-2025
export function calculatePercentageforAP_used(data) {
  const percentCalculate =
    data?.current === 0
      ? 0
      : ((data?.ap_used - data?.current) / Math.abs(data?.current)) * 100;
  return Number(percentCalculate.toFixed(2));
}

export function checkFileUploadSize(templateObj) {
  const payload = JSON.stringify(templateObj);
  if (payload.length > 2097152) {
    // 2MB limit
    let fileUploadError =
      "The file is uploading; please wait until the process is complete.";
    return fileUploadError;
  }
}

export const getBase64FromSource = async (source) => {
  // Case 1: If source is a selector (starts with "." or "#")
  if (
    typeof source === "string" &&
    (source.startsWith(".") || source.startsWith("#"))
  ) {
    const chartContainer = document.querySelector(source);

    if (!chartContainer) {
      console.error(`Chart container not found for selector: ${source}`);
      return null;
    }

    const canvas = await html2canvas(chartContainer, {
      scale: 2,
      useCORS: true,
      backgroundColor: "transparent",
    });

    return canvas.toDataURL("image/png");
  }

  // Case 2: Assume it's an image URL
  return new Promise((resolve, reject) => {
    const img = new globalThis.Image();
    img.crossOrigin = "Anonymous";
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      const dataURL = canvas.toDataURL("image/png");
      resolve(dataURL);
    };
    img.onerror = (err) => {
      console.error("Image load error:", err);
      reject(new Error("Failed to load image"));
    };
    img.src = source;
  });
};
export function centsToDollars(cents) {
  return `$${(cents / 100).toFixed(2)}`;
}

function toTitleCase(str) {
  return str
    ?.split(" ")
    ?.map((word) => {
      // Match: optional leading punctuation, first letter, middle letters, optional trailing punctuation
      const match = word.match(
        /^([^a-zA-Z]*)([a-zA-Z])([a-zA-Z]*)([^a-zA-Z]*)$/,
      );
      if (match) {
        const [, leadPunct, firstChar, rest, trailPunct] = match;
        return (
          leadPunct + firstChar.toUpperCase() + rest.toLowerCase() + trailPunct
        );
      }
      return word.toLowerCase(); // fallback for numbers/symbols
    })
    .join(" ");
}

export function transformBankName(name) {
  const containsBondAI = /BOND\.AI/i.test(name);

  if (containsBondAI) {
    const cleaned = name.replaceAll(/BOND\.AI/gi, "").trim();
    return `BOND.AI ${toTitleCase(cleaned)}`;
  } else {
    return toTitleCase(name);
  }
}

export function getSelectedCardName() {
  const pathSegments = globalThis.location.pathname.split("/");
  const urlParams = pathSegments[7];
  let name = "";
  let key = "";
  if (urlParams === "CrossSellOpp") {
    name = "Product Opportunities";
    key = CARD_NAME.OPPORTUNITIE;
  } else if (urlParams === "Secondary_Consumer") {
    name = "Deposit Opportunities";
    key = CARD_NAME.BOOST_DEPOSIT;
  } else if (urlParams === "Ghost_Consumer") {
    name = "Ghost Consumers";
    key = CARD_NAME.GHOST_CONSUMER;
  } else if (urlParams === "Top_Merchant") {
    name = "Top Merchants";
    key = CARD_NAME.TOP_MERCHANT;
  }
  return { name, key };
}
export function calculateAPValue(segmentData, metricsObject) {
  return segmentData?.map((data) => {
    let final_AP_value;

    if (
      data?.key === "net_interest_income" ||
      data?.key === "non_interest_expense" ||
      data?.key === "total_assets" ||
      data?.key === "total_loans" ||
      data?.key === "total_deposits"
    ) {
      const delta_value = (metricsObject?.[data?.key] ?? 0) / 100;
      const AP_value_segment = (data.forecasted * delta_value).toFixed(2);
      final_AP_value = data?.forecasted
        ? Number.parseFloat(AP_value_segment) + data?.forecasted
        : 0;
    } else {
      const delta_value = metricsObject?.[data?.key] ?? 0;
      final_AP_value = data?.forecasted
        ? (data?.forecasted + delta_value).toFixed(2)
        : 0;
    }

    const forecasted_trend =
      data?.current === 0
        ? 0
        : ((data?.forecasted - data?.current) / Math.abs(data?.current)) * 100;

    const autopilot_trend =
      data?.current === 0
        ? 0
        : ((final_AP_value - data?.current) / Math.abs(data?.current)) * 100;

    const final_forecasted = data?.current === 0 ? 0 : data?.forecasted;

    final_AP_value = data?.current === 0 ? 0 : final_AP_value;

    return {
      ...data,
      forecasted_trend: forecasted_trend.toFixed(2),
      autopilot_trend: autopilot_trend.toFixed(2),
      forecasted: final_forecasted,
      final_AP_value,
    };
  });
}

export const getOrdinalSuffix = (value) => {
  if (value === null || value === undefined) return "";

  const num = Number(value);
  if (Number.isNaN(num)) return "";

  const lastTwoDigits = num % 100;

  // Special case: 11, 12, 13 → "th"
  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
    return "th";
  }

  switch (num % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

export const secureRandom = () => {
  const arr = new Uint32Array(1);
  globalThis.crypto.getRandomValues(arr);
  return arr[0] / 2 ** 32;
};
